import { Inject, Injectable, Optional } from "@angular/core";
import { AppContextConfigService } from "@obg/ngx.core";
import { LogType } from "@obg/ngx.global";
import { LoggingService } from "@obg/ngx.global.evo";
import { Request } from "express";
import { upperFirst } from "lodash-es";

import { NODE_LOGGER_SERVICE_TOKEN, NodeLoggerService, REQUEST_TOKEN } from "../model";

@Injectable()
export class UniversalLoggingService extends LoggingService {
	constructor(
		@Optional() @Inject(NODE_LOGGER_SERVICE_TOKEN) private nodeLoggerService: NodeLoggerService | null,
		@Optional() @Inject(REQUEST_TOKEN) private request: Request,
		private appContextConfigService: AppContextConfigService
	) {
		super();
	}

	log(type: LogType, message: string | Error, data?: any) {
		if (this.nodeLoggerService) {
			this.nodeLoggerService.log(
				upperFirst(type),
				typeof message !== "string" ? `${message.message}: ${message.stack}` : message,
				data,
				this.request,
				this.appContextConfigService.getApiToken()
			);
			return;
		}

		super.log(type, message, data);
	}
}
